import { Box, Divider, Typography } from '@mui/material'

const infoStyle = {

}

const flexRowStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
}

const Info = () => (
  <Box sx={infoStyle} className='info'>
    <Typography variant='h3'>Controls</Typography>
    <Box sx={{marginTop: '24px'}}>
      <Typography variant='h4'>Keyboard</Typography>
      <Divider sx={{marginY: 1}}/>
      <Box>
        <Box sx={flexRowStyle}>
          <Typography>movement</Typography><Typography>arrows or WASD</Typography>
        </Box>
        <Box sx={flexRowStyle}>
          <Typography>wait</Typography><Typography>space</Typography>
        </Box>
        <Box sx={flexRowStyle}>
          <Typography>select</Typography><Typography>Enter</Typography>
        </Box>
        <Box sx={flexRowStyle}>
        <Typography>inventory</Typography><Typography>i</Typography>
        </Box>
        <Box sx={flexRowStyle}>
        <Typography>character stats</Typography><Typography>c</Typography>
        </Box>
        <Box sx={flexRowStyle}>
        <Typography>close menu</Typography><Typography>Escape</Typography>
        </Box>
      </Box>
    </Box>
    <Box sx={{marginTop: '24px'}}>
      <Typography variant='h4'>Touch</Typography>
      <Divider sx={{marginY: 1}}/>
      <Box>
        <Box sx={flexRowStyle}>
          <Typography>movement</Typography><Typography>swipe</Typography>
        </Box>
        <Box sx={flexRowStyle}>
          <Typography>fast movement</Typography><Typography>swipe & hold</Typography>
        </Box>
        <Box sx={flexRowStyle}>
          <Typography>action</Typography><Typography>just touch stuff</Typography>
        </Box>
      </Box>
    </Box>
  </Box>
)

export default Info
